// import React from 'react';
// import "./ResourceMain.css";

// const LeftSection = () => {
//   return (
//     <div className={`card p-4 ${"leftSection"}`}>
//       <h2 className="text-primary">Mastering Active Listening and Clarity</h2>
//       <p className="text-muted">
//         Develop active listening skills and learn to communicate clearly to ensure customers feel heard and understood, minimizing miscommunication.
//       </p>
//       <h3 className="mt-4">My Development Plan</h3>
//       <ul className="list-group">
//         <li className="list-group-item">Understand Active Listening</li>
//         <li className="list-group-item">Practice Listening Techniques</li>
//         <li className="list-group-item">Improve Clarity in Responses</li>
//         <li className="list-group-item">Practice in Real-Life Scenarios</li>
//         <li className="list-group-item">Monitor Progress</li>
//       </ul>

//     </div>
//   );
// };





import React, { useState } from "react";
import "./LeftSection.css";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import starImage from '../../../assets/images/starImage.png';
import { useLocation } from "react-router-dom";


const sections = [
    "Understand Active Listening",
    "Practice Listening Techniques",
    "Improve Clarity in Responses",
    "Practice in Real-Life Scenarios",
    "Monitor Progress",
];




const LeftSection = () => {
    const [openSections, setOpenSections] = useState([]);
    const [activeControl, setActiveControl] = useState(null);
    const location = useLocation();
    const resource = location.state?.resource; // Get passed resource data

    const developmentPlan = resource?.developmentPlan || []; // Ensure it's an array

    const toggleSection = (index) => {
        setOpenSections((prev) =>
            prev.includes(index) ? prev.filter((item) => item !== index) : [...prev, index]
        );
    };

    const expandAll = () => {
        setOpenSections(developmentPlan.map((_, i) => i));
        setActiveControl("expand");
    };

    const collapseAll = () => {
        setOpenSections([]);
        setActiveControl("collapse");
    };

    return (
        <div className="learning-resource-card">
           
            {/* Header Section */}
            <div className="learning-header-section">
                <div className="content">
                    <p className="guide-label">A SELF-DEVELOPMENT GUIDE</p>
                    <h3 className="guide-title">{resource?.title}</h3>
                    <p className="description">{resource?.description}</p>
                </div>
                <div className="right-side-image">
                    <img src={starImage} alt="Pattern" />
                </div>
            </div>

            {/* Development Plan */}
            <div className="development-plan">
                <div className="step-by">STEP-BY-STEP</div>
                <h4 className="plan-title">My Development Plan</h4>

                {/* Expand/Collapse Buttons */}
                <div className="toggle-controls">
                    <button
                        className={`toggle-button ${activeControl === "expand" ? "active" : "inactive"}`}
                        onClick={expandAll}
                    >
                        <IoIosArrowDropdown className="icon" />
                        Expand All
                    </button>
                    <div className="divider"></div>
                    <button
                        className={`toggle-button ${activeControl === "collapse" ? "active" : "inactive"}`}
                        onClick={collapseAll}
                    >
                        <IoIosArrowDropup className="icon" />
                        Collapse All
                    </button>
                </div>

                {/* Accordion Sections */}
                <div className="accordion-title">
                    {developmentPlan.map((item, index) => (
                        <div key={index} className="accordion-item">
                            <div className="accordion-header" onClick={() => toggleSection(index)}>
                                <span>{item.step}</span>
                                {openSections.includes(index) ? (
                                    <FaChevronUp className="accordion-icon" />
                                ) : (
                                    <FaChevronDown className="accordion-icon" />
                                )}
                            </div>
                            {openSections.includes(index) && (
                                <div className="accordion-content">
                                    <p>{item.description}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LeftSection;



